import React from 'react';
import { WhySection, WhyCard } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Link from 'next/link';
import Image from "next/image";

const WhyCardComponent = ({ blok }: { blok: WhyCard & SbBlokData }) => {
  return (
    <div className="col-md-12 col-lg-9 col-xl-6" {...storyblokEditable(blok)}>
      <div className="usp card card-lighter">
        {blok.icon && (
          <Image
            height="100"
            width="100"
            alt={blok.icon.alt || ''}
            className="usp-image mx-auto"
            src={blok.icon.filename || ''}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
        {blok.title && <h3 className="text-reset mb-3">{blok.title}</h3>}
        {blok.description && <p className="mb-0">{blok.description}</p>}
        {blok.cta_button && blok.cta_button_link && (
          <Link href={blok.cta_button_link.url || ''}
                className="btn btn-primary mt-3">
            {blok.cta_button}
          </Link>
        )}
      </div>
    </div>
  );
};

const WhySectionComponent = ({ blok }: { blok: WhySection & SbBlokData }) => {
  return (
    <section className="usp-section py-4 py-md-5" {...storyblokEditable(blok)}>
      <div className="container">
        {blok.title && (
          <h2 className="text-white text-center mb-4 mb-md-5">{blok.title}</h2>
        )}
        <div className="row justify-content-center gy-3 gx-md-3 gy-xl-0 text-dark">
          {blok.cards?.map((card) => (
            <WhyCardComponent key={card._uid} blok={{...card, _editable: ''}} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySectionComponent;